import React from 'react';
import { copyFor } from 'config';
import { Crate, FlexCrate } from '@perch-labs/shrike';

import {
  SecondaryBadge,
  StyledListItem,
  StyledContainer,
  StyledHeading,
  StyledSupportingText,
  StyledTooltipContainer,
} from '../line-items.style';

const getCopy = copyFor(
  'billing.statement.lineItems.vnmSolarChargeDelayedCredit'
);

export const VnmSolarChargeDelayedCreditLineItem: React.FunctionComponent =
  () => {
    return (
      <StyledListItem data-testid="vnm-solar-charge-line-item">
        <StyledContainer>
          <FlexCrate flexDirection="column" gap="8px">
            <StyledTooltipContainer>
              <StyledHeading color="secondary">
                {getCopy('title')}
              </StyledHeading>
            </StyledTooltipContainer>
          </FlexCrate>
          <SecondaryBadge margin={{ right: '-8px' }} size="small">
            {getCopy('badges.delayed')}
          </SecondaryBadge>
        </StyledContainer>
        <FlexCrate
          flexDirection="column"
          margin={{ top: '16px' }}
          gap="16px"
          width="100%"
        >
          <Crate padding="0 64px 0 0">
            <StyledSupportingText color="secondary">
              {getCopy('subtitle')}
            </StyledSupportingText>
          </Crate>
        </FlexCrate>
      </StyledListItem>
    );
  };
